const PENDING_STRIPE_RETURN_KEY = 'santtai.pendingStripeReturn';

export type PendingStripeReturn = {
  bookingId: number;
  tripId: number;
  boatId?: number;
  currency: string;
  value: number;
  paymentPath?: 'stripe' | 'pay_later';
  paymentIntentId?: string | null;
};

export const savePendingStripeReturn = (payload: PendingStripeReturn): void => {
  try {
    sessionStorage.setItem(PENDING_STRIPE_RETURN_KEY, JSON.stringify(payload));
  } catch {
    // no-op
  }
};

export const consumePendingStripeReturn = (): PendingStripeReturn | null => {
  try {
    const raw = sessionStorage.getItem(PENDING_STRIPE_RETURN_KEY);
    if (!raw) {
      return null;
    }
    sessionStorage.removeItem(PENDING_STRIPE_RETURN_KEY);
    const parsed = JSON.parse(raw) as PendingStripeReturn;
    if (!parsed?.bookingId) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};
